export default "__VITE_ASSET__DQYxnv1V__"